import { useState } from "react";
import { Button } from "../../ui/button";
import { AddPhoneDialog } from "./AddPhoneDialog";
import { VerifyPhoneDialog } from "./VerifyPhoneDialog";
import { toast } from "sonner";
import { default as phoneApi } from "@/shared/api/phone";


export const AddPhoneMessage = ({ phone, verified, onPhoneVerified }) => {
    const [showAddPhone, setShowAddPhone] = useState(false);
    const [showVerify, setShowVerify] = useState(false);
    const [newPhone, setNewPhone] = useState(null);
    const [isVerified, setIsVerified] = useState(false);

    const handlePhoneSubmit = async (phone) => {
        try {
            const res = await phoneApi.addPhone("+" + phone);
            if (res) {
                setNewPhone(phone)
                setShowAddPhone(false)
                setShowVerify(true)
            }

        } catch (err) {
            toast.error("Ошибка при добавлении номера телефона");
            console.error(err.message);
        }
    }

    const handleVerify = async (code) => {
        try {
            const res = await phoneApi.verifyPhone(newPhone, code);
            if (res) {
                toast.success("Телефон подтвержден");
                setShowVerify(true);
                setIsVerified(true);
                onPhoneVerified(phone);
            }
        } catch (err) {
            toast.error("Ошибка при подтверждении номера телефона");
            console.error(err.message);
        }
    }

    if ((phone && verified) || isVerified) return null;

    if (!phone) {
        return (
            <div className="bg-card flex flex-col items-center bg-olive-50 border rounded-lg p-6 mb-8">
                <h3 className="text-center">Добавьте свой номер телефона чтобы управлять своими записями</h3>
                <Button onClick={() => setShowAddPhone(true)}>Добавить номер телефона</Button>
                <AddPhoneDialog
                    open={showAddPhone}
                    onOpenChange={setShowAddPhone}
                    onSubmit={handlePhoneSubmit}
                />
                <VerifyPhoneDialog
                    open={showVerify}
                    onOpenChange={setShowVerify}
                    phoneNumber={newPhone}
                    onVerify={handleVerify}
                />
            </div>
        )
    }

    if (phone && !verified) {
        return (
            <div className="bg-card flex flex-col items-center bg-olive-50 border rounded-lg p-6 mb-8">
                <h3 className="text-center">Пожалуйста, подтвердите свой номер телефона</h3>
                <Button onClick={() => setShowVerify(true)}>Подтвердить номер телефона</Button>
                <VerifyPhoneDialog
                    open={showVerify}
                    onOpenChange={setShowVerify}
                    phoneNumber={phone}
                    onVerify={handleVerify}
                />
            </div>
        )
    }
}